import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import {
  getAllVerificationSuccess,
  getAllVerificationFailure,
} from '../actions/UserVerificationActionCreator';

const _getAllVerificationsEndpoint =
  '/ibapi/v2/banks/{bank-id}/user/verification/all';

export const getAllVerifications = () => {
  let url = envConfig.apiBaseUrlPAAS + _getAllVerificationsEndpoint;
  if (envConfig.stubConfig) {
    url = envConfig.stubConfig.timelineStub.AccountListConnection;
  }
  ApiUtils.makeAjaxCall(
    {
      apiVersion: config.apiVersions.userVerifications,
      method: 'GET',
      url,
      addAuthToken: true,
    },
    (body) => {
      getAllVerificationSuccess(body);
    },
    (error) => {
      getAllVerificationFailure(error);
    }
  );
};
